var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-qr-code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.17,
    height: 16.172,
    viewBox: "0 0 16.17 16.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162652",
    "data-name": "Group 162652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162651",
    "data-name": "Group 162651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M5.56,0H0V5.56H5.56ZM4.448,4.448H1.112V1.112H4.448Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147703",
    "data-name": "Rectangle 147703",
    width: 1,
    height: 1,
    transform: "translate(2 2)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    d: "M352,0V5.56h5.56V0Zm4.448,4.448h-3.336V1.112h3.336Z",
    transform: "translate(-341.389)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147704",
    "data-name": "Rectangle 147704",
    width: 1,
    height: 1,
    transform: "translate(13 2)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    d: "M0,357.56H5.56V352H0Zm1.112-4.448H4.448v3.336H1.112Z",
    transform: "translate(0 -341.389)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147705",
    "data-name": "Rectangle 147705",
    width: 1,
    height: 1,
    transform: "translate(2 13)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147706",
    "data-name": "Rectangle 147706",
    width: 2,
    height: 1,
    transform: "translate(8)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M194.224,35.336h1.112V34.224h1.112V33.112h-3.336V32H192v2.224h2.224Z",
    transform: "translate(-186.126 -30.888)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147707",
    "data-name": "Rectangle 147707",
    width: 1,
    transform: "translate(6 5)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    d: "M196.448,160h-1.112v1.112H192v1.112h4.448Z",
    transform: "translate(-186.126 -155.011)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4676",
    "data-name": "Path 4676",
    d: "M1.112,195.336H2.224v-1.112H1.112V192H0v4.448H1.112Z",
    transform: "translate(0 -186.126)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147708",
    "data-name": "Rectangle 147708",
    width: 1,
    height: 1,
    transform: "translate(2 6)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M99.336,196.448h2.224v-1.112h-1.112v-1.112H98.224V192H97.112v2.224H96v2.224h1.112v-1.112h2.224Z",
    transform: "translate(-93.099 -186.126)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147709",
    "data-name": "Rectangle 147709",
    width: 1,
    height: 2,
    transform: "translate(9 8)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M195.336,352H192v1.112h2.224v3.336H192v1.112h3.336v-1.112h2.224v-1.112h-2.224Z",
    transform: "translate(-186.198 -341.389)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147710",
    "data-name": "Rectangle 147710",
    width: 1,
    height: 1,
    transform: "translate(6 13)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147711",
    "data-name": "Rectangle 147711",
    width: 1,
    height: 3,
    transform: "translate(10 11)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    d: "M387.336,416H384v3.336h1.112v-2.224h2.224Z",
    transform: "translate(-372.277 -403.165)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147712",
    "data-name": "Rectangle 147712",
    width: 2,
    height: 1,
    transform: "translate(14 15)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147713",
    "data-name": "Rectangle 147713",
    width: 1,
    height: 1,
    transform: "translate(15 11)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4680",
    "data-name": "Path 4680",
    d: "M353.112,291.336h1.112V288H352v1.112h1.112Z",
    transform: "translate(-341.025 -279.099)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4681",
    "data-name": "Path 4681",
    d: "M355.336,193.112h-1.112V192h-1.112v1.112H352v1.112h4.448v-1.112h1.112V192h-2.224Z",
    transform: "translate(-341.389 -186.014)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147714",
    "data-name": "Rectangle 147714",
    width: 2,
    height: 1,
    transform: "translate(14 9)",
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQrCode);
export default __webpack_public_path__ + "static/media/ic-qr-code.55e526c9405e89f853e7366ce3e1c4e9.svg";
export { ForwardRef as ReactComponent };